import * as React from 'react'
import { Link } from 'react-router-dom'

import {
  AP_SLUG,
  BUILDING_AI_KNOWLEDGE_SLUG,
  COLLEGE_BOARD_SLUG,
  INTERDISCIPLINARY_SCIENCE,
  PRE_AP_SLUG,
  SOCIAL_STUDIES_SLUG,
  SPRING_BOARD_SLUG,
  WORLD_HISTORY_1200_TO_PRESENT_SLUG,
  WORLD_HISTORY_1750_TO_PRESENT_SLUG,
  TEKS_SLUG,
  LITERATURE_SLUG,
  FISHTANK_ELA_GRADE_7_SLUG,
  FISHTANK_ELA_GRADE_8_SLUG,
  THIRD_GRADE_SLUG,
  FOURTH_GRADE_SLUG,
  FIFTH_GRADE_SLUG,
  SIXTH_GRADE_SLUG,
  SEVENTH_GRADE_SLUG,
  EIGHTH_GRADE_SLUG,
  ENGLISH_I_SLUG,
  ENGLISH_II_SLUG
} from '../../../Shared'
import LeavingModal from './leaving_modal'
import parsedQueryParams from './parsedQueryParams'

const quillLogoGreenSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-green.svg`

interface AssignmentFlowNavigationProps {
  button?: JSX.Element
  courseSlug?: string
  isFromDiagnosticPath?: boolean
  unitTemplateId?: string
  unitTemplateName?: string
}

const learningProcessSlug = 'learning-process'
const diagnosticSlug = 'diagnostic'
const activityTypeSlug = 'activity-type'
const collegeBoardSlug = COLLEGE_BOARD_SLUG
const activityLibrarySlug = 'activity-library'
const selectClassesSlug = 'select-classes'
const featuredActivityPacksSlug = 'featured-activity-packs'
const preApSlug = PRE_AP_SLUG
const apSlug = AP_SLUG
const springBoardSlug = SPRING_BOARD_SLUG
const socialStudiesSlug = SOCIAL_STUDIES_SLUG
const worldHistory1750ToPresentSlug = WORLD_HISTORY_1750_TO_PRESENT_SLUG
const worldHistory1200ToPresentSlug = WORLD_HISTORY_1200_TO_PRESENT_SLUG
const interdisciplinaryScienceSlug = INTERDISCIPLINARY_SCIENCE
const buildingAIKnowledgeSlug = BUILDING_AI_KNOWLEDGE_SLUG
const teksSlug = TEKS_SLUG
const literatureSlug = LITERATURE_SLUG
const fishtankElaGrade7Slug = FISHTANK_ELA_GRADE_7_SLUG
const fishtankElaGrade8Slug = FISHTANK_ELA_GRADE_8_SLUG
const thirdGradeSlug = THIRD_GRADE_SLUG
const fourthGradeSlug = FOURTH_GRADE_SLUG
const fifthGradeSlug = FIFTH_GRADE_SLUG
const sixthGradeSlug = SIXTH_GRADE_SLUG
const seventhGradeSlug = SEVENTH_GRADE_SLUG
const eighthGradeSlug = EIGHTH_GRADE_SLUG
const englishISlug = ENGLISH_I_SLUG
const englishIISlug = ENGLISH_II_SLUG

const slash = (index: number) => (
  <span
    aria-hidden="true"
    className="slash"
    key={index}
  >
    /
  </span>
)

const learningProcess = () => (
  <a
    className="focus-on-light"
    href="/assign"
    key="learning-process"
  >
    Learning process
  </a>
)

const diagnostic = () => (
  <Link
    className="focus-on-light"
    key="diagnostic"
    to={`/assign/${diagnosticSlug}`}
  >
    Diagnostic
  </Link>
)

const activityType = () => (
  <Link
    className="focus-on-light"
    key="activity-type"
    to={`/assign/${activityTypeSlug}`}
  >
    Activity type
  </Link>
)

const collegeBoard = () => (
  <Link
    className="focus-on-light"
    key="college-board"
    to={`/assign/${collegeBoardSlug}`}
  >
    College Board
  </Link>
)

const createActivityPack = () => (
  <Link
    className="focus-on-light"
    key="custom-activity-pack"
    to={`/assign/${activityLibrarySlug}`}
  >
    Activity library
  </Link>
)

const selectClasses = () => (
  <Link
    className="focus-on-light"
    key="assign-"
    to={`/assign/${selectClassesSlug}`}
  >
    Assign
  </Link>
)

const activityPack = () => (
  <Link
    className="focus-on-light"
    key="activity-pack"
    to={`/assign/${featuredActivityPacksSlug}`}
  >
    Activity pack
  </Link>
)

const preAp = () => (
  <Link
    className="focus-on-light"
    key="activity-pack"
    to={`/assign/${preApSlug}`}
  >
    Pre-AP
  </Link>
)

const ap = () => (
  <Link
    className="focus-on-light"
    key="activity-pack"
    to={`/assign/${apSlug}`}
  >
    AP
  </Link>
)

const springBoard = () => (
  <Link
    className="focus-on-light"
    key="activity-pack"
    to={`/assign/${springBoardSlug}`}
  >
    SpringBoard
  </Link>
)

const socialStudies = () => (
  <Link
    className="focus-on-light"
    key="social-studies"
    to={`/assign/${socialStudiesSlug}`}
  >
    Social Studies
  </Link>
)

const worldHistory1200ToPresent = () => (
  <Link
    className="focus-on-light"
    key="world-history-1200-to-present"
    to={`/assign/${socialStudiesSlug}/${worldHistory1200ToPresentSlug}`}
  >
    World History: 1200 CE - Present
  </Link>
)

const worldHistory1750ToPresent = () => (
  <Link
    className="focus-on-light"
    key="world-history-1750-to-present"
    to={`/assign/${socialStudiesSlug}/${worldHistory1750ToPresentSlug}`}
  >
    World History: 1750 CE - Present
  </Link>
)

const science = () => (
  <Link
    className="focus-on-light"
    key="science"
    to={`/assign/${interdisciplinaryScienceSlug}`}
  >
    Science
  </Link>
)

const buildingAIKnowledge = () => (
  <Link
    className="focus-on-light"
    key="building-ai-knowledge"
    to={`/assign/${interdisciplinaryScienceSlug}/${buildingAIKnowledgeSlug}`}
  >
    Building AI Knowledge
  </Link>
)

const teks = () => (
  <Link
    className="focus-on-light"
    key="teks"
    to={`/assign/${teksSlug}`}
  >
    TEKS Activity Packs
  </Link>
)

const literature = () => (
  <Link
    className="focus-on-light"
    key="literature"
    to={`/assign/${literatureSlug}`}
  >
    Literature
  </Link>
)

const fishtankGrade7 = () => (
  <Link
    className="focus-on-light"
    key="fishtank-ela-grade-7"
    to={`/assign/${literatureSlug}/${fishtankElaGrade7Slug}`}
  >
    Fishtank ELA Grade 7
  </Link>
)

const fishtankGrade8 = () => (
  <Link
    className="focus-on-light"
    key="fishtank-ela-grade-8"
    to={`/assign/${literatureSlug}/${fishtankElaGrade8Slug}`}
  >
    Fishtank ELA Grade 8
  </Link>
)

const thirdGradeTeks = () => (
  <Link
    className="focus-on-light"
    key="third-grade-teks"
    to={`/assign/${teksSlug}/${thirdGradeSlug}`}
  >
    3rd Grade
  </Link>
)

const fourthGradeTeks = () => (
  <Link
    className="focus-on-light"
    key="fourth-grade-teks"
    to={`/assign/${teksSlug}/${fourthGradeSlug}`}
  >
    4th Grade
  </Link>
)

const fifthGradeTeks = () => (
  <Link
    className="focus-on-light"
    key="fifth-grade-teks"
    to={`/assign/${teksSlug}/${fifthGradeSlug}`}
  >
    5th Grade
  </Link>
)

const sixthGradeTeks = () => (
  <Link
    className="focus-on-light"
    key="sixth-grade-teks"
    to={`/assign/${teksSlug}/${sixthGradeSlug}`}
  >
    6th Grade
  </Link>
)

const seventhGradeTeks = () => (
  <Link
    className="focus-on-light"
    key="seventh-grade-teks"
    to={`/assign/${teksSlug}/${seventhGradeSlug}`}
  >
    7th Grade
  </Link>
)

const eighthGradeTeks = () => (
  <Link
    className="focus-on-light"
    key="eighth-grade-teks"
    to={`/assign/${teksSlug}/${eighthGradeSlug}`}
  >
    8th Grade
  </Link>
)

const englishITeks = () => (
  <Link
    className="focus-on-light"
    key="english-i-teks"
    to={`/assign/${teksSlug}/${englishISlug}`}
  >
    English I
  </Link>
)

const englishIITeks = () => (
  <Link
    className="focus-on-light"
    key="english-ii-teks"
    to={`/assign/${teksSlug}/${englishIISlug}`}
  >
    English II
  </Link>
)

const STEP_ONE = 'step-one'
const STEP_TWO = 'step-two'
const STEP_THREE = 'step-three'
const STEP_FOUR = 'step-four'
const STEP_FIVE = 'step-five'

const individualFeaturedActivityPack = (unitTemplateId: string, unitTemplateName: string) => {
  let link = `/assign/${featuredActivityPacksSlug}/${unitTemplateId}`
  const collegeBoardActivityTypeSlug = parsedQueryParams()[collegeBoardSlug]
  if (collegeBoardActivityTypeSlug) {
    link += `?${collegeBoardSlug}=${collegeBoardActivityTypeSlug}`
  }
  return (
    <Link
      className="focus-on-light"
      key="featured-activity-pack"
      to={link}
    >
      {unitTemplateName}
    </Link>
  )
}

const collegeBoardSlugsToLinks = {
  [preApSlug]: preAp(),
  [apSlug]: ap(),
  [springBoardSlug]: springBoard(),
}

const contentHubSlugsToLinks = {
  [WORLD_HISTORY_1750_TO_PRESENT_SLUG]: worldHistory1750ToPresent(),
  [WORLD_HISTORY_1200_TO_PRESENT_SLUG]: worldHistory1200ToPresent(),
  [BUILDING_AI_KNOWLEDGE_SLUG]: buildingAIKnowledge(),
}

const teksSlugsToLinks = {
  [THIRD_GRADE_SLUG]: thirdGradeTeks(),
  [FOURTH_GRADE_SLUG]: fourthGradeTeks(),
  [FIFTH_GRADE_SLUG]: fifthGradeTeks(),
  [SIXTH_GRADE_SLUG]: sixthGradeTeks(),
  [SEVENTH_GRADE_SLUG]: seventhGradeTeks(),
  [EIGHTH_GRADE_SLUG]: eighthGradeTeks(),
  [ENGLISH_I_SLUG]: englishITeks(),
  [ENGLISH_II_SLUG]: englishIITeks(),
}

const literatureSlugsToLinks = {
  [FISHTANK_ELA_GRADE_7_SLUG]: fishtankGrade7(),
  [FISHTANK_ELA_GRADE_8_SLUG]: fishtankGrade8(),
}

const routeLinks = {
  [learningProcessSlug]: () => [slash(1), learningProcess()],
  [diagnosticSlug]: () => [slash(1), learningProcess(), slash(2), diagnostic()],
  [activityTypeSlug]: () => [slash(1), learningProcess(), slash(2), activityType()],
  [preApSlug]: () => [slash(1), learningProcess(), slash(2), collegeBoard(), slash(3), preAp()],
  [apSlug]: () => [slash(1), learningProcess(), slash(2), collegeBoard(), slash(3), ap()],
  [springBoardSlug]: () => [slash(1), learningProcess(), slash(2), collegeBoard(), slash(3), springBoard()],
  [collegeBoardSlug]: () => [slash(1), learningProcess(), slash(2), collegeBoard()],
  [activityLibrarySlug]: () => [slash(1), learningProcess(), slash(2), createActivityPack()],
  [socialStudiesSlug]: ({ courseSlug }: { courseSlug?: string }) => {
    if (courseSlug) {
      return [slash(1), learningProcess(), slash(2), socialStudies(), slash(3), contentHubSlugsToLinks[courseSlug]]
    } else {
      return [slash(1), learningProcess(), slash(2), socialStudies()]
    }
  },
  [interdisciplinaryScienceSlug]: ({ courseSlug }: { courseSlug?: string }) => {
    if (courseSlug) {
      return [slash(1), learningProcess(), slash(2), science(), slash(3), contentHubSlugsToLinks[courseSlug]]
    } else {
      return [slash(1), learningProcess(), slash(2), science()]
    }
  },
  [teksSlug]: ({ courseSlug }: { courseSlug?: string }) => {
    if (courseSlug) {
      return [slash(1), learningProcess(), slash(2), teks(), slash(3), teksSlugsToLinks[courseSlug]]
    } else {
      return [slash(1), learningProcess(), slash(2), teks()]
    }
  },
  [literatureSlug]: ({ courseSlug }: { courseSlug?: string }) => {
    if (courseSlug) {
      return [slash(1), learningProcess(), slash(2), literature(), slash(3), literatureSlugsToLinks[courseSlug]]
    } else {
      return [slash(1), learningProcess(), slash(2), literature()]
    }
  },
  [selectClassesSlug]: ({
    unitTemplateId,
    unitTemplateName,
    isFromDiagnosticPath,
  }: {
    unitTemplateId?: string
    unitTemplateName?: string
    isFromDiagnosticPath?: boolean
  }) => {
    if (isFromDiagnosticPath) {
      return [
        slash(1),
        learningProcess(),
        slash(2),
        diagnostic(),
        slash(3),
        selectClasses(),
      ]
    }

    const collegeBoardActivityTypeSlug = parsedQueryParams()[collegeBoardSlug]
    if (collegeBoardActivityTypeSlug) {
      return [
        slash(1),
        learningProcess(),
        slash(2),
        collegeBoard(),
        slash(3),
        collegeBoardSlugsToLinks[collegeBoardActivityTypeSlug],
        slash(4),
        individualFeaturedActivityPack(unitTemplateId!, unitTemplateName!),
        slash(5),
        selectClasses(),
      ]
    }

    const base = [slash(1), learningProcess(), slash(2), activityType(), slash(3)]
    if (unitTemplateId && unitTemplateName) {
      return base.concat([
        activityPack(),
        slash(4),
        individualFeaturedActivityPack(unitTemplateId, unitTemplateName),
        slash(5),
        selectClasses(),
      ])
    }
    return base.concat([createActivityPack(), slash(4), selectClasses()])
  },
  [featuredActivityPacksSlug]: ({
    unitTemplateId,
    unitTemplateName,
  }: {
    unitTemplateId?: string
    unitTemplateName?: string
  }) => {
    const collegeBoardActivityTypeSlug = parsedQueryParams()[collegeBoardSlug]
    if (collegeBoardActivityTypeSlug) {
      return [
        slash(1),
        learningProcess(),
        slash(2),
        collegeBoard(),
        slash(3),
        collegeBoardSlugsToLinks[collegeBoardActivityTypeSlug],
        slash(4),
        individualFeaturedActivityPack(unitTemplateId!, unitTemplateName!),
      ]
    }

    const base = [slash(1), learningProcess(), slash(2), activityType(), slash(3), activityPack()]
    if (unitTemplateId && unitTemplateName) {
      return base.concat([slash(4), individualFeaturedActivityPack(unitTemplateId, unitTemplateName)])
    }
    return base
  },
}

const routeProgress = {
  [learningProcessSlug]: () => STEP_ONE,
  [diagnosticSlug]: () => STEP_TWO,
  [activityTypeSlug]: () => STEP_TWO,
  [collegeBoardSlug]: () => STEP_TWO,
  [socialStudiesSlug]: ({ courseSlug }: { courseSlug?: string }) => (courseSlug ? STEP_THREE : STEP_TWO),
  [teksSlug]: ({ courseSlug }: { courseSlug?: string }) => (courseSlug ? STEP_THREE : STEP_TWO),
  [literatureSlug]: ({ courseSlug }: { courseSlug?: string }) => (courseSlug ? STEP_THREE : STEP_TWO),
  [interdisciplinaryScienceSlug]: ({ courseSlug }: { courseSlug?: string }) =>
    courseSlug ? STEP_THREE : STEP_TWO,
  [worldHistory1750ToPresentSlug]: () => STEP_THREE,
  [worldHistory1200ToPresentSlug]: () => STEP_THREE,
  [buildingAIKnowledgeSlug]: () => STEP_THREE,
  [preApSlug]: () => STEP_THREE,
  [apSlug]: () => STEP_THREE,
  [springBoardSlug]: () => STEP_THREE,
  [activityLibrarySlug]: () => STEP_THREE,
  [selectClassesSlug]: () => STEP_FIVE,
  [featuredActivityPacksSlug]: ({
    unitTemplateId,
    unitTemplateName,
  }: {
    unitTemplateId?: string
    unitTemplateName?: string
  }) => {
    if (unitTemplateId && unitTemplateName) {
      return STEP_FOUR
    }
    return STEP_THREE
  },
}

export default class AssignmentFlowNavigation extends React.Component<
  AssignmentFlowNavigationProps,
  any
> {
  constructor(props: AssignmentFlowNavigationProps) {
    super(props)

    this.state = {
      showLeavingModal: false,
    }
  }

  toggleLeavingModal = () => {
    this.setState({ showLeavingModal: !this.state.showLeavingModal })
  }

  getSlug() {
    const path = location.pathname
    // will grab whatever comes after '/assign/' and before another slash
    return path.split('/')[2]
  }

  renderButton() {
    const { button } = this.props
    return button ? button : null
  }

  renderLinks() {
    const { courseSlug, isFromDiagnosticPath, unitTemplateId, unitTemplateName } = this.props
    let elements
    try {
      elements = routeLinks[this.getSlug()]({
        courseSlug,
        isFromDiagnosticPath,
        unitTemplateId,
        unitTemplateName,
      })
    } catch {
      elements = []
    }

    return (
      <ol className="links">
        {elements.map((element, index) => {
          const isSlash =
            element.props &&
            element.props.className &&
            element.props.className.includes('slash')
          return (
            <li
              key={index}
              {...(isSlash ? { 'aria-hidden': 'true', role: 'presentation' } : {})}
            >
              {element}
            </li>
          )
        })}
      </ol>
    )
  }

  renderProgressBar() {
    const { courseSlug, unitTemplateId, unitTemplateName } = this.props
    let className
    try {
      className = routeProgress[this.getSlug()]({
        courseSlug,
        unitTemplateId,
        unitTemplateName,
      })
    } catch {
      className = null
    }
    return (
      <div
        aria-hidden="true"
        className="progress-bar"
      >
        <div className={className} />
      </div>
    )
  }

  renderLeavingModal() {
    if (this.state.showLeavingModal) {
      return <LeavingModal cancel={this.toggleLeavingModal} />
    }
  }

  render() {
    return (
      <nav
        aria-label="Assignment flow navigation"
        className="assignment-flow-navigation"
      >
        {this.renderLeavingModal()}
        <div className="assignment-flow-navigation-container">
          <div className="left">
            <button
              aria-label="Leave assignment flow"
              className="interactive-wrapper focus-on-light"
              onClick={this.toggleLeavingModal}
              type="button"
            >
              <img
                alt="green Quill logo"
                src={quillLogoGreenSrc}
              />
            </button>
            {this.renderLinks()}
          </div>
          <div className="right">
            {this.renderButton()}
          </div>
        </div>
        {this.renderProgressBar()}
      </nav>
    )
  }
}
